<template>
  <div class="page-footer">
    <div class="content-footer" v-if="org.isMainSite">
      <div class="footer-container">
        <div class="item">
          <span>关于我们：</span>
          <a href="http://www.ulearning.com.cn" target="_blank">关于文华</a>
          <a :href="`${UMOOC_SERVER_HOST}/agreements/user.html`" target="_blank">用户协议</a>
          <a :href="`${UMOOC_SERVER_HOST}/agreements/privacy.html`" target="_blank">隐私政策</a>
        </div>
        <div class="item">
          <span>友情链接：</span>
          <a href="https://www.smartedu.cn" target="_blank">国家智慧教育公共服务平台</a>
          <a href="http://mooc.people.cn/publicCourse/index.html" target="_blank">人民公开课</a>
        </div>
        <div class="item">
          Copyright©2022 北京文华在线教育科技股份有限公司
        </div>
        <div class="item">
          <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备12003602号-6</a>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502036460" target="_blank"><img src="@/assets/images/police.png" alt=""><span>京公网安备 11010502036460号</span></a>
          <a href="http://www.ulearning.com.cn/copy_copy_wenhua.html" target="_blank">互联网出版许可证 新出网证（京）字218号</a>
          <a href="http://www.ulearning.com.cn/copy_copy_wenhua.html" target="_blank"> 出版物经营许可证 新出发京批字第直120206号</a>
        </div>
      </div>
    </div>
    <div class="content-footer footer-org" v-else-if="!org.isMainSite && org.footer.type == 0">
      <div class="footer-container">
        <div class="org-info">
          <ul class="links">
            <li>友情链接</li>
            <li v-for="item in org.footer.list" :key="item.id"><a :href="item.linkUrl" target="_blank">{{item.linkName}}</a></li>
            <li><a href="https://help.ulearning.cn/" target="_blank">帮助中心</a></li>
          </ul>
          <div class="info">
            <span class="title">{{org.title}}</span>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502036460" target="_blank"><img src="@/assets/images/police.png" alt=""><span>京公网安备 11010502036460号</span></a>
          </div>
        </div>
        <div class="powered">
          <div class="desc">Powered by</div>
          <img src="@/assets/images/umooc_icon.png" alt="">
        </div>
      </div>
    </div>
    <div class="content-footer footer-custom" v-else-if="!org.isMainSite && org.footer.type != 0">
      <div class="custom-content" v-html="org.footer.list[0].html"></div>
    </div>
  </div>
  
</template>

<script>
import { UMOOC_SERVER_HOST } from '@/config'
import { mapGetters } from 'vuex'
export default {
  name: 'content-footer',
  data () {
    return {
      UMOOC_SERVER_HOST
    }
  },
  computed: {
    ...mapGetters({org: 'org/org'})
  },
  created () {
    console.log(this.org)
  }
}
</script>

<style lang="scss" scoped>
.content-footer{
  background-color: #444;
  color: $--color-white;
  .footer-container{
    @include page-width;
    padding: 24px 0;
    .item{
      display: flex;
      padding: 6px 0;
      align-content: center;
      &>a{
        display: flex;
        margin-right: 14px;
        align-content: center;
        color: $--color-white;
      }
    }
    
  }
}
.footer-org{
  background-color: #2e323e;
  .footer-container{
    display: flex;
    align-items: center;
    a{
      color: #fff;
    }
    .org-info{
      flex: 1;
      
    }
    .links{
      display: flex;
      li{
        margin-right: 10px;
      }
    }
    .info{
      display: flex;
      align-items: center;
      margin-top: 4px;
      a{
        margin-left: 10px;
        font-size: 0;
        img{
          margin-right: 6px;
          vertical-align: middle;
        }
        span{
          vertical-align: middle;
          font-size: 14px;
          display: inline-block;
        }
      }
      
    }
    .powered{
      .desc{
        line-height: 24px;
        color: #fff;
      }
    }
  }
}

</style>